<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPhone_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M18.88 17.248c-.459.814-1.35 1.384-2.386 1.528-1.992.278-4.55-.945-7.438-3.831-3.528-3.528-4.03-5.992-3.831-7.438.143-1.035.714-1.927 1.529-2.385a1.356 1.356 0 0 1 1.838.487l1.552 2.586a1.363 1.363 0 0 1-.206 1.668l-.727.749a12.453 12.453 0 0 0 1.857 2.32 15.104 15.104 0 0 0 2.264 1.87l.81-.745a1.358 1.358 0 0 1 1.663-.202l2.586 1.552c.638.384.852 1.191.489 1.84Z"
    />
</svg>
